export const anyRequestApiTemplate = {
  name: 'request',
  desc: '默认接口',
  dbMethod: '',
  required: false,
  request: {},
  response: {}
};
//# sourceMappingURL=anyRequest.js.map
